import { getInjectedProviderFromWindow } from '@dynamic-labs-sdk/client/core';

import type { OneKeyBitcoinInjectedProvider } from '../OneKeyBitcoinInjectedProvider.types';

const ONEKEY_BITCOIN_PROVIDER_LOCATOR = '$onekey.btc';

export const getOneKeyBitcoinInjectedProvider = () => {
  return getInjectedProviderFromWindow<OneKeyBitcoinInjectedProvider>(
    ONEKEY_BITCOIN_PROVIDER_LOCATOR
  );
};
